export function isNumericId(value) {
  return /^\d+$/.test(String(value));
}

export function isVimeoCdnUrl(url) {
  try {
    const u = new URL(url);
    return u.protocol === 'https:' && /(^|\.)vimeocdn\.com$/.test(u.hostname);
  } catch {
    return false;
  }
}
